class SiteSales {

    // Create a Sales Record
    // LineItem = { sales_product_id, quantity }
    async createOneTimeSale({ lineItems, accountId, paymentIntentId }) {
        const account_id = accountId;
        const payment_intent_id = paymentIntentId;
        const sales_products = lineItems;
        const response = await fetch("/sales/purchase", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            },
            body: JSON.stringify({ account_id, payment_intent_id, sales_products })
        }).then((response) => response.json());

        const { sale_id } = response;
        localStorage.setItem('sale_id', sale_id);
        return response;
    }

    async createSubscriptionSale({ salesProductIds, setupIntentId }) {
        return await fetch('/sales/create-subscription-sale', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ setup_intent_id: setupIntentId, sales_product_ids: salesProductIds })
        });
    }
}

export default SiteSales;